
<div id="donation" class="subBlockContainer">
  <div class="subBlockContent">
    <child-header [title]="title" (closeEvent)="close()"></child-header>
    <div *ngIf="loadContent" class="child-body">
      <div class="inner-subBlock-wrapper">
        <!-- <div class="page-title-wrapper">
          <div class="title blade-title-font">
            {{title}}
          </div>
          <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
        </div> -->
        <div><img (click)="goToFNPWLink()" style="cursor: pointer;" src="../images/FoundationForNationalParksWildlife.png"></div>
        <p class="text-lg dlink">
          Would you like to make a donation to help heal our land through bushfire recovery?
          <i (click)="goToFNPWLink()" class="fas fa-info-circle"></i>
        </p>
        <p class="text-lg">
          <b>Make a donation and Dicker Data will match it dollar for dollar*!</b>
        </p>

        <div class="div-donate">
            <div class="options-container">
              <ng-container *ngFor="let item of donationOptionsList">
                <div class="options-items" [class.active]="selectedValue == item.value" (click)="selectDonation(item.value)">
                    <div class="options-content">
                      <!-- <i class="far fa-dot-circle"></i> -->
                      <b>DONATE</b><br/>
                      <span class="options-value">${{ item.value }}</span> <br/>
                      {{ item.description }}
                    </div>
                </div>
              </ng-container>
                <div class="options-items" [class.active]="selectedValue == 0" (click)="selectDonation(0)">
                  <div class="options-content">
                    <b>NO DONATION</b> <br/>
                    <div class="text-small">
                      I do not want to <br/> make a donation  <br/> with this order
                    </div>
                  </div>
                </div>
              </div>
          </div>
          <div class="text-note">
            *Donations over $2 are tax deductible
          </div>
          <div class="text-note">
            *Dicker Data will match the first $10,000 donated by reseller partners
          </div>
      </div>
      <div class="div-next">
        <button type="button" class="button button-red button-large"
        (click)="moveToNext()">Next</button>
      </div>
      <div id="bottom-navigation">
        <button (click)="goPrevious()">Previous</button>
        <span>&nbsp;|&nbsp;</span>
     

        <ng-container [ngSwitch]="backto">
          <button *ngSwitchCase="'renewal'" (click)="backtoRenewals()">Back to renewals
          </button>
          <button *ngSwitchCase="'quote'"  (click)="backtoQuotes()">Back to quotes
          </button>
          <button *ngSwitchDefault  (click)="backtoCart()">Back to cart</button>        
        </ng-container>


        <!-- <ng-container *ngIf="serial;else goRenewals">
          <button class="btnLink" (click)="backtoRenewals()">Back to renewals</button>
        </ng-container>
        <ng-template #goRenewals>
          <button class="btnLink" (click)="backtoCart()">Back to cart</button>
        </ng-template>
         -->
        <!-- <button (click)="backtoCart()">Back to cart</button> -->
      </div>
    </div>
    <loading-screen *ngIf="!loadContent" backDropWidth='350' [showInnerLoading]="true"
    (currentLoadingStatus)="onLoading($event)"></loading-screen>
  </div>
</div>